export const projects = [
  {
    title: "Done With It, Mern APP",
    description: "Personal Project",
    tools:
      "Backend: NodeJS, Express JS, fronted: React JS, DB: MongoDB (v.2)  material UI, RESTful API",
    type: "View Code",
    url: "https://github.com/Yuv-Rajd/simple_diary",
    imgUrl:
      "https://images.pexels.com/photos/4068318/pexels-photo-4068318.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    title: "CRYPTO AIRDROP MANAGEMENT SYSTEM (RDBMS)",
    description: "Academic Project",
    tools: "PHP, MySQL, HTML, CSS, Bootstrap",
    type: "View Code",
    url: "https://github.com/Yuv-Rajd/Crypto-Airdrop-Management-System",
    imgUrl:
      "https://images.pexels.com/photos/8369649/pexels-photo-8369649.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    title: "QUEUE OPERATION ANIMATION",
    description: "Academic Project",
    tools: " C++, Visual Studio",
    type: "Live Project",
    url: "https://yuvarajd.pythonanywhere.com/",
    imgUrl:
      "https://media.gettyimages.com/id/1350571367/vector/modern-blocks-building-logistics-blockchain-abstract-background.jpg?s=612x612&w=0&k=20&c=wRn4R5btKGtfcRiaAbfGUYPAmVFng89N5-RcLEWs58o=",
  },
  {
    title: "BRAIN TUMOR DETECTION",
    description: "Academic Project",
    type: "Live Project",
    tools: "Deep Learning, CNN, Python, Flask",
    url: "https://yuvarajad.pythonanywhere.com/",
    imgUrl:
      "https://previews.123rf.com/images/carottart/carottart2305/carottart230501115/205592858-human-brain-on-black-background-3d-rendering-3d-illustration.jpg",
  },
  {
    title: "NEWS APP ",
    description: "Personal Project",
    tools: "Frontend: ReactJS, Bootstrap, DB:CSV file",
    type: "Live Project",
    url: "https://64f9a17ea774160008863014--astonishing-griffin-23c618.netlify.app/",
    imgUrl:
      "https://images.pexels.com/photos/9967888/pexels-photo-9967888.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
];
